import IconButton from '@components/v2/ui/IconButton/IconButton';
import { InputAdornment } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';
import { ElementType, forwardRef, useState } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import TextField, { TextFieldProps } from '../TextField/TextField';

type Props = Omit<TextFieldProps, 'type' | 'multiline' | 'rows' | 'minRows' | 'maxRows'>;

const PasswordField = forwardRef<HTMLInputElement | HTMLTextAreaElement, Props>(
  ({ slotProps, ...props }, ref) => {
    const { translate } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => setIsVisible((visible) => !visible);
    const toggleIcon = (isVisible ? EyeOff : Eye) as ElementType;

    return (
      <TextField
        {...props}
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        slotProps={{
          ...slotProps,
          input: {
            ...(slotProps?.input as object),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  icon={toggleIcon}
                  ariaLabel={translate(LangEnum.GLOBAL_TOGGLE_PASSWORD_VISIBILITY)}
                  disabled={props.disabled}
                  onClick={toggleVisibility}
                />
              </InputAdornment>
            ),
          },
        }}
      />
    );
  },
);

PasswordField.displayName = 'PasswordField';
export type { Props as PasswordFieldProps };
export default PasswordField;
